__webpack_require__.p = "/Aps-DW-Curriculum/";